export default {
  GOOGLE_ANALYTICS_ID: 'googleAnalyticsId',
  GOOGLE_WEBMASTER_CODE: 'googleWebmasterCode',
  COOKIEBOT_ID: 'cookiebotId',
};
